import { useMemo } from "react";
import "../theme/Indicadores.css";
import numbro from "numbro";

import { icons } from "../const/icons";
import { SkeletonOrdersCard } from "./SkeletonOrdersCard";

export const TableAvegache = ({ averageData, isLoading = false, hasError = false }) => {
  const calculations = useMemo(() => {
    // Si no hay datos o hay error, retornar valores en cero
    if (!averageData || hasError) {
      return {
        ticketReal: "0.0",
        ticketPtto: "0.0",
        ticketAA: "0.0",
        ticketPttoAvg: 0,
        ticketAAAvg: 0,
      };
    }

    const { fnticket_prom = 0, fnticket_prom_ppto = 0, fnticket_prom_aa = 0 } = averageData;

    const formatValue = (value) =>
      value === 0 ? "0.0" : numbro(value).format({ thousandSeparated: true, mantissa: 1 });

    const calcPercentage = (real, compare) =>
      compare === 0 ? 0 : Math.round((real * 100) / compare);

    return {
      ticketReal: formatValue(fnticket_prom),
      ticketPtto: formatValue(fnticket_prom_ppto),
      ticketAA: formatValue(fnticket_prom_aa),
      ticketPttoAvg: calcPercentage(fnticket_prom, fnticket_prom_ppto),
      ticketAAAvg: calcPercentage(fnticket_prom, fnticket_prom_aa),
    };
  }, [averageData, hasError]);

  // Solo mostrar skeleton durante carga
  if (isLoading) {
    return <SkeletonOrdersCard />;
  }

  // Siempre mostrar la tarjeta con datos (reales o en cero)
  return (
    <div className="container-table-sale-right">
      <div className="box-top-table-sale-right">
        <div className="box-sale-icon-right">
          <img className="IconImage" src={icons.average} alt="Ticket Promedio" />
          <div className="title-top-table-indicadores">Ticket Promedio</div>
        </div>
        <div className="title-top-table-indicadores-real">Real</div>
        <div className="text-tota-real">${calculations.ticketReal}</div>
      </div>

      <div className="box-body-table-sale-right">
        <div className="item-box-table-sales1-right">
          <span className="text-vs">Vs PPTO</span>
          <p className="text-porcent">{calculations.ticketPttoAvg}%</p>
          <span className="text-presupues">${calculations.ticketPtto}</span>
        </div>

        <div className="item-box-table-sales3-right">
          <span className="text-vs">Vs AA</span>
          <p className="text-porcent">{calculations.ticketAAAvg}%</p>
          <span className="text-presupues">${calculations.ticketAA}</span>
        </div>
      </div>
    </div>
  );
};
